
define('CustomPDPLink.Main', [
    'CustomPDPLink.View'
], function addCustomPDPMessage(
    CustomPDPLinkView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var pdp = container.getComponent('PDP');

            if (pdp) {
                pdp.addChildView('StockDescription', function addPDPCustomView() {
                    return new CustomPDPLinkView({ 
                        container: container 
                    });
                });
            }
        }
    };
});
